import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import NonAuthLayout from '../layouts/NonAuthLayout';
import VerticalLayout from '../layouts/index';

import { authProtectedRoutes, publicRoutes } from './allRoutes';
import { AuthProtected } from './AuthProtected';
import { RedirectRoute } from './RedirectProtected';

function Index() {
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        closeOnClick
        pauseOnHover
        draggable
      />
      <Routes>
        {/* Public Routes */}
        {publicRoutes.map(route => (
          <Route
            path={route.path}
            element={
              <RedirectRoute>
                <NonAuthLayout>{route.component}</NonAuthLayout>
              </RedirectRoute>
            }
            key={route.path}
          />
        ))}

        {/* Protected Routes */}
        {authProtectedRoutes.map(route => (
          <Route
            path={route.path}
            element={
              <AuthProtected>
                <VerticalLayout>{route.component}</VerticalLayout>
              </AuthProtected>
            }
            key={route.path}
          />
        ))}
      </Routes>
    </>
  );
}

export default Index;
